/**
 * 学术动态
 */

import Container from '@/containers';

const xsdtRouter = {
    path: '/xsdt',
    component: Container,
    redirect: '/xsdt/index',
    name: 'XueShuDongTai',
    meta: {
        title: '学术动态'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/xsdt'),
            name: 'XueShuDongTai',
            meta: {
                title: '学术动态',
                index:0
            }
        },
        {
            path: 'zyxs',
            component: () => import('@/views/xsdt/gnky'),
            name: 'GuoNeiKeYan',
            meta: {
                title: '国内科研活动相关情况',
                subTitle:'学术动态',
                returnLink:'/xsdt',
            }
        },
        {
            path: 'gnqk',
            component: () => import('@/views/xsdt/gnqk'),
            name: 'GuoNeiQiKan',
            meta: {
                title: '国内期刊发展情况',
                subTitle:'学术动态',
                returnLink:'/xsdt'
            }
        },
        {
            path: 'gnxs',
            component: () => import('@/views/xsdt/gnxs'),
            name: 'GuoNeiXueShu',
            meta: {
                title: '国内学术研究相关情况',
                subTitle:'学术动态',
                returnLink:'/xsdt'
            }
        },
        {
            path: 'zwxs',
            component: () => import('@/views/xsdt/zwxs'),
            name: 'ZhongWaiXueShu',
            meta: {
                title: '中外学术研究比较',
                subTitle:'学术动态',
                returnLink:'/xsdt'
            }
        }
    ]
};

export default xsdtRouter;